<template>
	<div class="hearing-list" ref="hearingListRef">
		<Spinner v-show="loading" />
		<ul class="grid-equalHeight ul--nostyling hearing-list__items">
			<li
				class="col-12 hearing-list__col list__col"
				v-for="item in listItems"
				:key="item.id"
			>
				<HearinglistItem
					:data="item"
					:dataLabels="dataProps"
				></HearinglistItem>
			</li>
		</ul>
		<pagination
			:totalItems="totalItems"
			:pageSize="parseInt(dataProps.pagesize)"
			:currentPage="parseInt(pageIndex)"
			@changePageIndex="changePageIndex"
			:ariaLabelPaginationGotoPage="dataProps.arialabelpaginationgotopage"
			:ariaLabelPaginationNav="dataProps.arialabelpaginationnav"
			:ariaLabelPaginationNext="dataProps.arialabelpaginationnext"
			:ariaLabelPaginationPrev="dataProps.arialabelpaginationprev"
			:ariaLabelPaginationActivePage="
				dataProps.arialabelpaginationactivepage
			"
		></pagination>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Pagination from "../pagination/pagination.vue";
import axios from "axios";
import Spinner from "../../../shared/script/vue/Spinner.vue";
import HearinglistItem from "./hearingListItem.vue";

const apiurl = ref("");
const listItems = ref([]);
const loading = ref(false);
const pageIndex = ref(0);
const totalItems = ref(0);
const hearingListRef = ref("hearingListRef");

let dataProps = {};

onMounted(() => {
	dataProps = hearingListRef.value?.parentElement?.dataset;
	apiurl.value = dataProps.apiurl;
	checkPageIndex();
	fetchData(false);
});

const fetchData = async (setQueryParameters = true) => {
	loading.value = true;
	try {
		let response = await axios.post(apiurl.value, {
			ContentId: parseInt(dataProps.contentid),
			PageIndex: parseInt(pageIndex.value)
		});

		if (response.status == 200) {
			listItems.value = response.data.items;
			totalItems.value = response.data.total;
		} else {
			listItems.value = [];
		}
		loading.value = false;
		if (setQueryParameters) {
			utilities.setQueryStringParameter("pageIndex", pageIndex.value);
		}
		return response;
	} catch (err) {
		console.warn(err);
		loading.value = false;
		return false;
	}
};

const changePageIndex = (index) => {
	let indexPlusOne = index + 1;
	if (
		indexPlusOne >= 1 &&
		indexPlusOne <= Math.ceil(totalItems.value / dataProps.pagesize)
	) {
		pageIndex.value = index;
		fetchData();
	}
};

const checkPageIndex = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const pageIndexParam = urlParams.get("pageIndex");
	if (pageIndexParam) {
		pageIndex.value = pageIndexParam;
	}
};
</script>

<style lang="scss" scoped></style>
